/* @flow */

import * as React from 'react';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import styles from './TakeOverPortal.style';
import { portalTakeOverId } from 'src/shared/app/base/constant/domConstants';

const useStyles = createUseThemeStyles(styles);

const TakeOverPortal = (): React.Node => {
  const classes = useStyles();
  return <div className={classes.root} id={portalTakeOverId} />;
};

export default React.memo<{}>(TakeOverPortal);
